var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _circle2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgNotFoundMask2 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 580,
    viewBox: "0 0 160 580",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 20,
    r: 80,
    fill: "#00BCDA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.0107 260V100",
    stroke: "#C9F001",
    strokeWidth: 8.25,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0107 260V100",
    stroke: "#C9F001",
    strokeWidth: 8.25,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M119.999 249.284L40.0073 110.713",
    stroke: "#C9F001",
    strokeWidth: 8.25,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M149.287 219.995L10.7158 140.004",
    stroke: "#C9F001",
    strokeWidth: 8.25,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M160 180.008H0",
    stroke: "#C9F001",
    strokeWidth: 8.25,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M149.287 140.004L10.7158 219.995",
    stroke: "#C9F001",
    strokeWidth: 8.25,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M119.999 110.713L40.0073 249.284",
    stroke: "#C9F001",
    strokeWidth: 8.25,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M136.569 236.573L23.4253 123.43",
    stroke: "#C9F001",
    strokeWidth: 8.25,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M136.569 236.573L23.4253 123.43",
    stroke: "#C9F001",
    strokeWidth: 8.25,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M157.28 200.704L2.73096 159.299",
    stroke: "#C9F001",
    strokeWidth: 8.25,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M157.28 159.299L2.73096 200.704",
    stroke: "#C9F001",
    strokeWidth: 8.25,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M136.569 123.43L23.4253 236.573",
    stroke: "#C9F001",
    strokeWidth: 8.25,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M100.701 102.732L59.2959 257.281",
    stroke: "#C9F001",
    strokeWidth: 8.25,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2959 102.732L100.701 257.281",
    stroke: "#C9F001",
    strokeWidth: 8.25,
    strokeMiterlimit: 10
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 340,
    r: 80,
    fill: "#00BCDA"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 500,
    r: 80,
    fill: "#00BCDA"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNotFoundMask2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/not-found-mask-2.4215ba4b0e69f0e992dcae6feb171d94.svg";